export const IS_MAC = window.navigator.userAgent.includes('Mac');
